import { setupIonicReact } from '@ionic/react';
import './styling/index.css';

setupIonicReact();

export * from './common/mediaQueries';
export * from './common/color.types';
export * from './views/components';
export * from './styling/icons';
export * from './common/hooks';
export * from './views/forms';

export {
  formatDecimalNumber,
  formatVelocityNumber,
  formatCompactNumber,
  numberFormatWithCommas,
  parseTextResponse,
  getColorBasedOnThreshold,
  // setNumberLocale, getNumberLocale and getLocaleForCountry are
  // deliberately NOT exported here — nothing outside common/utils.tsx (and
  // its own test) needs them. applyNumberLocaleForCompany is the only
  // public entry point every consumer actually calls.
  applyNumberLocaleForCompany,
} from './common/utils';

export * from './components';
export type { CitationMetadata } from './views/components/Citation/Citation.types';
export type {
  CitationPreviewProps,
  CitationModalProps,
} from './views/components/CitationModal/CitationModal.types';

// SPRINT 79